<script>
import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  props: {
    chartData: {
      type: Object,
      default: null
    },

    options: {
      type: Object,
      default: null
    },

    drillOption: {
      default: null
    }
  },

  data () {
    return {
      selectedData: {}
    }
  },

  mounted () {
    setTimeout(() => {
      this.renderChart(this.chartData, {
        onClick: this.click,
        onHover: (_, dataset) => {
          if (!dataset.length) {
            this.selectedData = {}
          }
        },
        tooltips: {
          xPadding: 10,
          yPadding: 8,
          caretPadding: 15,
          bodyFontFamily: 'Roboto',
          titleFontFamily: 'Roboto',
          cornerRadius: 5,
          displayColors: false,
          backgroundColor: 'rgba(120,120,120,.85)',
          position: 'nearest',
          callbacks: {
            footer: (label, dataset) => {
              if (this.options.scales.xAxes[0].stacked) {
                this.selectedData.value = dataset.datasets[label[0].datasetIndex].label
                this.selectedData.groupment = dataset.labels[label[0].index].toLowerCase()
              } else {
                this.selectedData.groupment = label[0].label
              }
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: this.chartData ? this.chartData.labels.length <= 4 : false,
          position: 'bottom',
          labels: {
            usePointStyle: true,
            padding: 15
          }
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false
              },
              ticks: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: false
              },
              ticks: {
                display: false
              }
            }
          ]
        },
        ...this.options
      })
    }, 500)
  },

  methods: {
    click () {
      if (this.selectedData) {
        this.$emit('selection', {
          ...this.selectedData,
          type: this.drillOption,
          isRounded: true
        })
      }
    }
  }
}
</script>
